import React, {useState} from 'react';

import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function ServicesSection({scrollToSection}) {
    const [activeFilter, setActiveFilter] = useState('all');

    const services = [
        {
            icon: "🏠",
            title: "Натяжные потолки",
            description: "Качественные натяжные потолки из ПВХ и тканевых материалов. Более 200 цветов и фактур.",
            price: "от 350 ₽/м²",
            oldPrice: "от 500 ₽/м²",
            category: "ceilings",
            popular: true,
            features: [
                "ПВХ и тканевые полотна",
                "Более 200 цветов",
                "Гарантия 10 лет",
                "Установка за 3-4 часа"
            ],
            badge: "Хит продаж"
        },
        {
            icon: "💡",
            title: "Освещение",
            description: "Профессиональный монтаж освещения: точечные светильники, люстры, светодиодные ленты.",
            price: "от 500 ₽/точка",
            oldPrice: "от 800 ₽/точка",
            category: "lighting",
            popular: false,
            features: [
                "Точечные светильники",
                "LED подсветка",
                "Люстры любой сложности",
                "Умное освещение"
            ],
            badge: null
        },
        {
            icon: "🎨",
            title: "Дизайн-проект",
            description: "Индивидуальный дизайн-проект с учетом особенностей вашего интерьера и пожеланий.",
            price: "от 3000 ₽",
            oldPrice: "от 5000 ₽",
            category: "design",
            popular: false,
            features: [
                "3D визуализация",
                "Подбор материалов",
                "Выезд дизайнера",
                "2 варианта проекта"
            ],
            badge: null
        },
        {
            icon: "🔧",
            title: "Ремонт потолков",
            description: "Ремонт и обслуживание натяжных потолков любой сложности с выездом на объект.",
            price: "от 1500 ₽",
            oldPrice: null,
            category: "repair",
            popular: false,
            features: [
                "Устранение порезов",
                "Замена полотна",
                "Слив воды",
                "Выезд мастера"
            ],
            badge: null
        },
        {
            icon: "📐",
            title: "Замер помещения",
            description: "Бесплатный выезд специалиста для точного замера и профессиональной консультации.",
            price: "Бесплатно",
            oldPrice: "1500 ₽",
            category: "measurement",
            popular: true,
            features: [
                "Точный лазерный замер",
                "Консультация специалиста",
                "Расчет стоимости",
                "В удобное время"
            ],
            badge: "Акция"
        },
        {
            icon: "⚡",
            title: "Срочный монтаж",
            description: "Экспресс-установка натяжных потолков за 24 часа без потери качества.",
            price: "от 450 ₽/м²",
            oldPrice: "от 600 ₽/м²",
            category: "express",
            popular: false,
            features: [
                "Монтаж за 24 часа",
                "Без потери качества",
                "Работа в выходные",
                "Срочный выезд"
            ],
            badge: null
        },
        {
            icon: "🔌",
            title: "Электромонтаж",
            description: "Профессиональный электромонтаж: проводка, розетки, выключатели, щитовое оборудование.",
            price: "от 2000 ₽",
            oldPrice: "от 3500 ₽",
            category: "electrical",
            popular: false,
            features: [
                "Замена проводки",
                "Установка розеток",
                "Монтаж щитов",
                "Заземление"
            ],
            badge: null
        }
    ];

    const filters = [
        {id: 'all', label: 'Все услуги'},
        {id: 'ceilings', label: 'Потолки'},
        {id: 'lighting', label: 'Освещение'},
        {id: 'design', label: 'Дизайн'},
        {id: 'repair', label: 'Ремонт'},
        {id: 'electrical', label: 'Электрика'}
    ];

    const filteredServices = activeFilter === 'all'
        ? services
        : services.filter(service => service.category === activeFilter);

    return (
        <section id="services" className="services-section">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="section-title">Наши услуги</h2>
                    <p className="section-subtitle">Полный спектр услуг по натяжным потолкам</p>

                    {/* Фильтры */}
                    <div className="service-filters mt-4">
                        {filters.map(filter => (
                            <button
                                key={filter.id}
                                className={`filter-btn ${activeFilter === filter.id ? 'active' : ''}`}
                                onClick={() => setActiveFilter(filter.id)}
                            >
                                {filter.label}
                            </button>
                        ))}
                    </div>
                </div>
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={20}
                    navigation={true}
                    pagination={{clickable: true}}
                    breakpoints={{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        576: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        992: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        }
                    }}
                    className="my-services-swiper"
                >
                    {filteredServices.map((service, index) => (
                        <SwiperSlide key={index}>
                            <div className={`service-card ${service.popular ? 'popular' : ''}`}>
                                {/* Бейдж */}
                                {service.badge && (
                                    <div className={`service-badge ${service.badge === 'Акция' ? 'sale' : 'hit'}`}>
                                        {service.badge}
                                    </div>
                                )}

                                {/* Иконка */}
                                <div className="service-icon-wrapper">
                                    <div className="service-icon">{service.icon}</div>
                                </div>

                                {/* Заголовок и описание */}
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>

                                {/* Цена */}
                                <div className="service-price-block">
                                    <div className="service-price">
                                        {service.price}
                                    </div>
                                    {service.oldPrice && (
                                        <div className="service-old-price">
                                            {service.oldPrice}
                                        </div>
                                    )}
                                </div>

                                {/* Характеристики */}
                                <ul className="service-features">
                                    {service.features.map((feature, idx) => (
                                        <li key={idx}>
                                            <span className="feature-icon">✓</span>
                                            {feature}
                                        </li>
                                    ))}
                                </ul>

                                {/* Кнопка */}
                                <button
                                    className="btn btn-custom btn-lg w-100"
                                    onClick={() => scrollToSection('contact')}
                                >
                                    {service.title === "Замер помещения" ? "Записаться на замер" : "Заказать"}
                                </button>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="cta-block text-center mt-5 animate-on-scroll">
                    <div className="cta-content">
                        <h3>Не нашли подходящую услугу?</h3>
                        <p>Свяжитесь с нами, и мы предложим индивидуальное решение</p>
                        <button
                            className="btn btn-custom btn-lg w-100"
                            onClick={() => scrollToSection('contact')}
                        >
                            Получить консультацию
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServicesSection;